module.exports = __webpack_public_path__ + "static/5-a912ff6640cef792cf11fef4092a6af0.jpeg";